export const TOKEN_UPDATE = 'TOKEN_UPDATE'
